import React from "react";
import "../css/Project.css";
function Projects() {
  return (
    <div className="projects" id="projects">
      <h2>Projects</h2>
      <div className="project">

      <div class="container">
          <div class="content">
            <div class="content-overlay"></div>
            <img
              class="content-image"
              src="https://onlinescreenshot.com/files/1640343000-2132150883-brighterbees.org.png" alt=""
            />
            <div class="content-details fadeIn-bottom">
              <h3 class="content-title">BrighterBees </h3>
              <p class="content-icons">
              <i class="devicon-html5-plain "></i>
              <i class="devicon-css3-plain "></i>
              <i class="devicon-javascript-plain "></i>
              <i class="devicon-python-plain"></i>

              </p>
              <p class="content-text">Platform for learning enthusiast in coding & development</p>
              <a href="https://brighterbees.org/" class="btn__project">Live </a>
         
            </div>
          </div>
        </div>


        <div class="container">
          <div class="content">
            <div class="content-overlay"></div>
            <img
              class="content-image"
              src="https://onlinescreenshot.com/files/1640343209-2132150883-developerhub.pythonanywhere.com.png"
            />
            <div class="content-details fadeIn-bottom">
              <h3 class="content-title">DevHub Platform</h3>
              <p class="content-icons">
              <i class="devicon-html5-plain "></i>
              <i class="devicon-css3-plain "></i>
              <i class="devicon-javascript-plain "></i>
              <i class="devicon-python-plain"></i>

              </p>
              <p class="content-text">Social Media Platform developers & Online College Platform Platform</p>
              <a href="https://developerhub.pythonanywhere.com/" class="btn__project">Live </a>
              <a href="https://github.com/devankit01" class="btn__project">Code </a>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="content">
            <div class="content-overlay"></div>
            <img
              class="content-image"
              src="https://onlinescreenshot.com/files/1640343601-2132150883-srimtexamination.pythonanywhere.com.png"
            />
            <div class="content-details fadeIn-bottom">
              <h3 class="content-title">Examination Portal 
             </h3>
              <p class="content-icons">
              <i class="devicon-html5-plain "></i>
              <i class="devicon-css3-plain "></i>
              <i class="devicon-javascript-plain "></i>
              <i class="devicon-python-plain"></i>

              </p>
              <p class="content-text">To Conduct College Examination Platform </p>
              <a href="https://srimtexamination.pythonanywhere.com/" class="btn__project">Live </a>
              <a href="https://github.com/devankit01" class="btn__project">Code </a>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="content">
            <div class="content-overlay"></div>
            <img
              class="content-image"
              src="https://onlinescreenshot.com/files/1640343472-2132150883-srimtnexxplora.pythonanywhere.com.png"
            />
            <div class="content-details fadeIn-bottom">
              <h3 class="content-title">Event Management</h3>
              <p class="content-icons">
              <i class="devicon-html5-plain "></i>
              <i class="devicon-css3-plain "></i>
              <i class="devicon-javascript-plain "></i>
              <i class="devicon-python-plain"></i>

              </p>
              <p class="content-text">To Manage College EVent Online includes Event Details, Volunteer and Place</p>
              <a href="http://srimtnexxplora.pythonanywhere.com/" class="btn__project">Live </a>
              <a href="https://github.com/devankit01" class="btn__project">Code </a>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="content">
            <div class="content-overlay"></div>
            <img
              class="content-image"
              src="https://onlinescreenshot.com/files/1640343724-2132150883-reactjs-google-clone.netlify.app.png"
            />
            <div class="content-details fadeIn-bottom">
              <h3 class="content-title"> Google Clone </h3>
              <p class="content-icons">
              <i class="devicon-react-plain "></i>
              <i class="devicon-css3-plain "></i>
              <i class="devicon-javascript-plain "></i>
           

              </p>
              <p class="content-text">Cloned Google UI and Search Feature</p>
              <a href="https://reactjs-google-clone.netlify.app/search" class="btn__project">Live </a>
              <a href="https://github.com/devankit01" class="btn__project">Code </a>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="content">
            <div class="content-overlay"></div>
            <img  class="content-image" src="https://i.ibb.co/dJdfWH0/undraw-Operating-system-re-iqsc.png" alt="undraw-Operating-system-re-iqsc"  />
            <div class="content-details fadeIn-bottom">
              <h3 class="content-title">devResources  </h3>
              <p class="content-icons">
              <i class="devicon-react-plain "></i>
              <i class="devicon-css3-plain "></i>
              <i class="devicon-redux-plain "></i>
              <i class="devicon-express-original"></i>

              </p>
              <p class="content-text"> Manage tools for developers and you can contribute also </p>
              <a href="https://github.com/devankit01" class="btn__project">Code </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
